import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

interface PlayerProps {
  token: string;
}

const PlayerYoutube: React.FC<PlayerProps> = ({ token }) => {
  const [videoUrl, setVideoUrl] = useState<string>('');

  const PLAYBACK_RATE_KEY = 'at:playbackRate';
  const [playbackRate] = useState<number>(() => {
    const newPlaybackRate = localStorage.getItem(PLAYBACK_RATE_KEY);
    if (newPlaybackRate) {
      return parseFloat(newPlaybackRate);
    }

    return 1;
  });

  const updatePlaybackRate = (newPlaybackRate: number) => {
    localStorage.setItem(PLAYBACK_RATE_KEY, newPlaybackRate.toString());
  };

  useEffect(() => {
    if (token.includes('youtube.com') || token.includes('youtu.be')) {
      setVideoUrl(token);
    } else {
      setVideoUrl(`https://www.youtube.com/watch?v=${token}`);
    }
  }, [token]);

  // https://github.com/CookPete/react-player#responsive-player
  return (
    <ReactPlayer
      width='100%'
      height='465px'
      url={videoUrl}
      controls={true}
      playbackRate={playbackRate}
      onPlaybackRateChange={updatePlaybackRate}
    />
  );
};

export default PlayerYoutube;
